import styled from 'styled-components';

export const FlexLayout = styled.div`
    display: flex;
    margin-bottom: 10px;
    gap: 10px;
`;

export const Header = styled.div`
    margin: 30px 0 10px 0;
    display: flex;
    flex-direction: column;
    font-size: 24px;

    &:before {
        width: 100%;
        height: 1px;
        background-color: black;
        content: '';
    }
`;

export const CellContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
`;
